export default __webpack_public_path__ + "static/media/carosal-1.667f46f4.png";